export const getBytesFromMb = (MbSize: number) => MbSize * 1024 * 1024;
